import { firebaseAction } from 'vuexfire'
import db from '@/plugins/db'

// initial state

let recorderMode = false
if (localStorage.recorderMode === 'true') recorderMode = true

const state = {
  currentHour: {},
  recorderMode: recorderMode,
}

// getters
const getters = {
  hourNumber: (state) => {
    return (!state.currentHour) ? undefined : state.currentHour.hourNumber
  },
  speedRound: (state) => () => {
    if (!state) return undefined
    return (!state.currentHour) ? undefined : state.currentHour.speedRound
  },
  getRecorderMode: (state) => () => {
    return state.recorderMode
  },
}

// actions
const actions = {
  bindCurrent: firebaseAction(context => {
    return context.bindFirebaseRef('currentHour', db.ref('current-hour'))
  }),
  changeCurrentHour: ({ commit }, { hourNumber: hour }) => {
    db.ref('current-hour').update({ hourNumber: hour })
  },
}

// mutations
const mutations = {
  toggleRecorderMode (state, recorderMode) {
    state.recorderMode = recorderMode
    localStorage.recorderMode = state.recorderMode
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
